<template>
  <div class="nodes-preview">
    <div class="caption">{{ $t("执行节点") }}</div>
    <div class="node-container">
      <div
        v-for="(nodesConfig, index) of cNodesList"
        :key="index"
        class="node-list"
      >
        <div
          v-if="nodesConfig[0] && nodesConfig[0] !== 'undefined'"
          class="title"
        >
          {{ nodesConfig[0] }}
        </div>
        <node
          v-for="(node, index2) in nodesConfig[1]"
          :key="index2"
          :node="node"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Node from "./node.vue";
import { reject, groupBy, toPairs } from "lodash-es";
// import * as _ from "lodash-es";

export default {
  name: "NodesPreview",
  components: {
    Node,
  },
  props: {
    nodeList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {};
  },
  computed: {
    cNodesList() {
      // const res = _.chain(this.nodeList)
      //   .filter((v) => v.hidden !== true)
      //   .groupBy((v) => v.group)
      //   .entries()
      //   .value();

      const res = toPairs(
        groupBy(reject(this.nodeList, { hidden: true }), "group"),
      );
      console.log("cNodesList", res);
      return res;
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.nodes-preview {
  position: absolute;
  z-index: 1000;
  background-color: #ffffff;
  left: 20px;
  top: 20px;
  // border: 1px solid #aeaeae;
  padding: 20px;
  border-radius: 8px;
}
.caption {
  font-size: 16px;
  font-weight: 400;
  padding-bottom: 14px;
  line-height: 28px;
  border-bottom: 1px solid #dcdcdc;
}
.title {
  color: #4b505b;
  font-size: 14px;
  margin-bottom: 10px;
  line-height: 28px;
}
.node-container {
  padding-top: 14px;
}
.node-list + .node-list {
  margin-top: 14px;
}
</style>
